<!-- <pageheader [entity]="headerEntity"></pageheader> -->
<div class="row">
  <div class="col-md-6">
    <div class="mb-6">
      <textbox [caption]="'User Name'" [formData]="entity" [disabled]="true" [fieldName]="'UserName'" [maxlength]="20"
        [(ngModel)]="entity.UserName" [mandatory]="true" ngDefaultControl>
      </textbox>
    </div>
  </div>
  <div class="col-md-6">
    <label>Old Password <span style="color: red">*</span></label>
    <div class="mb-6">
      <input type="password" class="form-control" [(ngModel)]="entity.OldPassword" placeholder="Old Password" />
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-md-6">
    <label>New Password <span style="color: red">*</span>
    </label>
    <div class="mb-6">
      <input type="password" class="form-control" (change)=" checkValidPassword()" [(ngModel)]="entity.NewPassword"
        placeholder="New Password" ngDefaultControl />
    </div>
  </div>
  <div class="col-md-6">
    <label>Confirm Password <span style="color: red">*</span></label>
    <div class="mb-6">
      <input type="password" class="form-control" placeholder="Confirm Password" [(ngModel)]="entity.ConfirmPassword"
        ngDefaultControl />
    </div>
  </div>
</div>

<div class="mt-3">
  <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'"
    [type]="'button'"></btn>
</div>
